<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{modalTitle}}</ion-title>
  </ion-toolbar>

  @if (modalMessage && modalMessage !== '') {
    <div class="ion-padding" style="text-align: center">
      <ion-label class="fs-pt-14">{{modalMessage}}</ion-label>
    </div>
  }

  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">
        <ion-button class="ion-margin-top ion-text-uppercase"
          color="primary" (click)="confirmFunction()" fill="solid"
        expand="block">{{confirmButtonText | uppercase}}</ion-button>
        <ion-button class="ion-margin-top ion-text-uppercase"
          color="danger" (click)="cancelFunction()" fill="solid"
        expand="block">{{cancelButtonText | uppercase}}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
